import React, { useState } from "react";
import buildUrl from "build-url-ts";
import { Link } from "src/types/link";

import _ from "lodash";
import styles from "./copylink.module.scss";
import Tooltip from "src/components/tooltip";

interface CopyLinkProps {
  link: Link;
}

const CopyLink: React.FC<CopyLinkProps> = ({ link }) => {

  const [linkCopied, setLinkCopied] = useState(false);
  const icon = React.useRef<HTMLSpanElement>(null);

  const copyLinkToClipboard = (utmUrl) => {
    const textArea = document.createElement("textarea");
    textArea.value = utmUrl || "";
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    setLinkCopied(true);
  }

  const copyLink = () => {
    let utmUrl = link.url;
    const queryParams: { [key: string]: string } = {};

    if (link.utmCampaign) {
      const utmCampaign = _.omitBy(link.utmCampaign, _.isNil);

      _.forOwn(utmCampaign, (value, key) => {
        queryParams[`utm_${key}`] = value;
      });

      const hasQueryParams = utmUrl ? utmUrl.includes('?') : false;
      const existingParams = utmUrl ? utmUrl.split('?')[1] : '';

      if (hasQueryParams && existingParams) {
        const existingUtmParams = new URLSearchParams(existingParams);
        _.forOwn(queryParams, (value, key) => {
          if (!existingUtmParams.has(key)) {
            utmUrl = buildUrl(utmUrl, { queryParams });
          }
        });
      } else {
        utmUrl = buildUrl(utmUrl, { queryParams });
      }
    }

    if(navigator.clipboard){
      navigator.clipboard.writeText(utmUrl || "").then(() => {
        setLinkCopied(true);
        if (icon.current) {
          icon.current.focus();
        }
      }).catch((error) => {
        console.error("Failed to copy the link: ", error);
        copyLinkToClipboard(utmUrl);
      });
    } else {
      copyLinkToClipboard(utmUrl);
    }

    setTimeout(() => {
      setLinkCopied(false);
      }, 3000);

  };
  return (
    <div className={styles.iconContainer}>
    <Tooltip content={linkCopied ? 'Link copied' : ''} placement='top'>
    <i
        role="button"
        tabIndex={0}
        className={"paperflite-link"}
        ref={icon}
        onClick={copyLink}
      ></i>
    </Tooltip>
    </div>
  );
};

export default CopyLink;